(() => {
  const init = (root) => {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';
    const input = root.querySelector('[data-faq-search]');
    const questions = [...root.querySelectorAll('[data-faq-question]')];
    const groups = [...root.querySelectorAll('[data-faq-group]')];
    const count = root.querySelector('[data-faq-count]');
    const clear = root.querySelector('[data-faq-clear]');
    const empty = root.querySelector('[data-faq-empty]');
    const normalize = (text) => text.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    const haystacks = new Map(questions.map(question => [question, normalize(question.textContent)]));
    let savedOpen = null;
    const filter = () => {
      const terms = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
      if (terms.length && !savedOpen) savedOpen = new Map(questions.map(question => [question, question.open]));
      let matches = 0;
      questions.forEach(question => {
        const match = terms.every(term => haystacks.get(question).includes(term));
        question.hidden = !match;
        if (match) matches += 1;
        if (terms.length) question.open = match;
        else if (savedOpen) question.open = savedOpen.get(question);
      });
      groups.forEach(group => {
        group.hidden = ![...group.querySelectorAll('[data-faq-question]')].some(question => !question.hidden);
        const related = group.querySelector('.a6-faq__related');
        if (related) related.hidden = terms.length > 0;
      });
      if (!terms.length) savedOpen = null;
      clear.hidden = !terms.length;
      empty.hidden = matches > 0;
      count.textContent = root.dataset.countLabel.replace('{count}', String(matches));
    };
    const reset = () => { input.value = ''; filter(); };
    input.addEventListener('input', filter);
    clear.addEventListener('click', () => { reset(); input.focus(); });
    root.querySelector('[data-faq-reset]').addEventListener('click', () => { reset(); input.focus(); });
    root.querySelectorAll('[data-faq-topic]').forEach(link => link.addEventListener('click', reset));
    const revealAnchor = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const question = questions.find(item => item.id === id);
      if (question) { reset(); question.open = true; }
    };
    window.addEventListener('hashchange', revealAnchor);
    root.querySelector('[data-faq-search-wrap]').hidden = false;
    filter();
    revealAnchor();
  };
  document.querySelectorAll('[data-a6-faq]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-a6-faq]').forEach(init));
})();
